/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable no-extra-boolean-cast */
import { Injectable } from '@angular/core';

@Injectable({
	providedIn: 'root',
})
export class IpbLocalStorageService {
	private storage: Storage;

	constructor() {
		this.storage = window.localStorage;
	}

	set(key: string, value: string): boolean {
		if (!!this.storage) {
			this.storage.setItem(key, JSON.stringify(value));
			return true;
		}
		return false;
	}

	get(key: string): any {
		if (!!this.storage) {
			let _value = this.storage.getItem(key) as string;
			try {
				_value = JSON.parse(_value);
				return _value;
			} catch (error) {
				return _value;
			}
		}
		return null;
	}

	remove(key: string): boolean {
		if (!!this.storage) {
			this.storage.removeItem(key);
			return true;
		}
		return false;
	}

	clear(): boolean {
		if (!!this.storage) {
			this.storage.clear();
			return true;
		}
		return false;
	}
}
